import script from "./xtx-city.vue?vue&type=script&setup=true&lang=js"
export * from "./xtx-city.vue?vue&type=script&setup=true&lang=js"

import "./xtx-city.vue?vue&type=style&index=0&id=6a850a49&scoped=true&lang=less"

import exportComponent from "D:\\hbuilderxpro\\jxshop\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a850a49"]])

export default __exports__